import { formatDateForAPI } from '@/features/invitee/utils/inviteeFormatters'

export function currentMonthRange() {
  const now = new Date()
  return {
    fromDt: formatDateForAPI(new Date(now.getFullYear(), now.getMonth(), 1)),
    toDt: formatDateForAPI(new Date(now.getFullYear(), now.getMonth() + 1, 0)),
  }
}

export function todayRange() {
  const today = formatDateForAPI(new Date())
  return { fromDt: today, toDt: today }
}

export function currentYearRange() {
  const now = new Date()
  return {
    fromDt: formatDateForAPI(new Date(now.getFullYear(), 0, 1)),
    toDt: formatDateForAPI(now),
  }
}
